import { baseApi } from '@/api/core/baseApi';
import { unwrapListResponse } from '@/api/patterns/crud';
import type { PlatformAuditLog, GetAuditLogsArgs } from '../types';

export const platformAuditLogsApi = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getPlatformAuditLogs: builder.query<PlatformAuditLog[], GetAuditLogsArgs | void>({
      query: (args) => {
        const params = new URLSearchParams();
        params.set('limit', String(args?.limit ?? 200));
        if (args?.includeViews) {
          params.set('includeViews', 'true');
        }
        return `/platform/audit-logs?${params.toString()}`;
      },
      transformResponse: unwrapListResponse<PlatformAuditLog>,
      providesTags: [{ type: 'AuditLog', id: 'LIST' }],
    }),
  }),
});

export const { useGetPlatformAuditLogsQuery } = platformAuditLogsApi;
